import createIcon from '../../createIcon';

/**
 * @component @name PersonAddAlt1
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOEMxMyA1Ljc5IDExLjIxIDQgOSA0QzYuNzkgNCA1IDUuNzkgNSA4QzUgMTAuMjEgNi43OSAxMiA5IDEyQzExLjIxIDEyIDEzIDEwLjIxIDEzIDhaTTE1IDEwVjEySDE4VjE1SDIwVjEySDIzVjEwSDIwVjdIMThWMTBIMTVaTTEgMThWMjBIMTdWMThDMTcgMTUuMzQgMTEuNjcgMTQgOSAxNEM2LjMzIDE0IDEgMTUuMzQgMSAxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonAddAlt1 = createIcon('PersonAddAlt1', [
  [
    'path',
    {
      d: 'M13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12C11.21 12 13 10.21 13 8ZM15 10V12H18V15H20V12H23V10H20V7H18V10H15ZM1 18V20H17V18C17 15.34 11.67 14 9 14C6.33 14 1 15.34 1 18Z',
      key: '1ao9cx',
    },
  ],
]);

export default PersonAddAlt1;
